// Valores por defecto de languagesSga.
export const defaultLanguagesSga = () => {
    return [];
};

// Valor por defecto de action.
export const defaultActionLanguage = () => {
    return "";
};

// Valor por defecto de language.
export const defaultLanguage = () => {
    return {
        id: null,
        code: null,
        name: null,
    };
};

// Valores por defecto de filterlanguagesSga.
export const defaultFilterSgaLanguages = () => {
    return {
        name: null,
        page: 1,
        total: 0,
        per_page: 10,
    };
};

// Valores por defecto de activeLanguages.
export const defaultActiveLanguages = () => {
    return [];
};

// Valores por defecto de languagesValidForApi.
export const languagesValidForApi = () => {
    return [];
};

export default {
    languagesSga: defaultLanguagesSga(),
    action: defaultActionLanguage(),
    language: defaultLanguage(),
    filterLanguagesSga: defaultFilterSgaLanguages(),
    activeLanguages: defaultActiveLanguages(),
    languagesValidForApi: languagesValidForApi(),
};
